import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {getMessage} from './../../utils/i18n';

import './loading.css';

class Loading extends Component {

    static propTypes = {
        noMessage: PropTypes.bool,
        message: PropTypes.string,
        additionalClassName: PropTypes.string
    };

    render() {
        const {noMessage = false, message = '', additionalClassName = ''} = this.props;
        return (
            <div className={['boLoadingComponentContainer', String(additionalClassName)].join(' ')}>
                <div className={"boLoadingComponent"}>
                    {noMessage ? null : <h1>{message || getMessage("app.message.loading")}</h1>}
                </div>
            </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/app/components/loading/index.js